<template>
    <el-dialog
        :title="title"
        :width="width"
        top="20vh"
        :visible.sync="visible"
        :before-close="done => !isSubmiting && done()"
        @close="onClose">
        <el-form
            ref="form"
            :model="formData"
            :rules="realRules"
            @submit.native.prevent="submit">
            <el-form-item
                :label="label"
                prop="msg">
                <el-input
                    :type="inputType"
                    :placeholder="placeholder"
                    :rows="4"
                    @blur="onHideInputBlur"
                    v-model="formData.msg"
                    autocomplete="off" />
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button
                type="info"
                round
                size="medium"
                :disabled="isSubmiting"
                @click="visible = false">
                取 消
            </el-button>
            <el-button
                type="primary"
                round
                size="medium"
                :loading="isSubmiting"
                @click="submit">
                确 定
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'AuctionComplaintDialog',
    props: {
        width: {
            type: String,
            default: '36%'
        },
        title: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: '请输入描述'
        },
        inputType: {
            type: String,
            default: 'textarea'
        },
        placeholder: {
            type: String,
            default: '描述最少为10字...'
        },
        minSize: {
            type: Number,
            default: 10
        },
        apiFn: {
            type: Function,
            required: true
        },
        successTip: {
            type: String,
            default: '操作成功！'
        },
        rules: {
            type: Object,
            default: null
        }
    },
    computed: {
        realRules () {
            return this.rules ? this.rules : {
                msg: [
                    { required: true, message: `请输入${this.title}内容`, trigger: 'blur' },
                    { min: this.minSize, message: `最少为${this.minSize}个字`, trigger: 'blur' }
                ]
            };
        }
    },
    data () {
        return {
            visible: false,
            formData: {
                msg: ''
            },
            isSubmiting: false
        };
    },
    created () {
        this._id = null;
    },
    methods: {
        onHideInputBlur () {
            this.formData.msg = this.formData.msg.trim();
        },
        open (str) {
            this.visible = true;
            this.$nextTick(() => {
                this.$refs.form.resetFields();
                if (str) this.formData.msg = str;
            });
        },
        validateField () {
            this.$refs.form.validateField('msg');
        },
        submit () {
            this.$refs.form.validate(async valid => {
                try {
                    if (valid) {
                        this.isSubmiting = true;
                        await this.apiFn(this.formData.msg);
                        this.$emit('done', null, this.formData.msg);
                        this.$message.success(this.successTip);
                        this.isSubmiting = false;
                        this.visible = false;
                    }
                } catch (err) {
                    this.$emit('done', err, this.formData.msg);
                    this.isSubmiting = false;
                    console.error(err);
                }
            });
        },
        onClose () {
            this.$emit('close');
        }
    }
};
</script>
